import { useState } from "react";
import { Check, Lock, Zap } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { startCheckout } from "@/lib/api";

const FEATURES = [
  "Workbook completo in PDF, tuo per sempre",
  "Quiz di autovalutazione del carico operativo",
  "Percorso guidato di 7 giorni, passo dopo passo",
  "Checklist di delega compilabili",
  "Schede e modelli pronti per assegnare responsabilità",
  "Sistema di misurazione del tempo recuperato",
  "Piano d'azione di 30 giorni",
  "Accesso all'area riservata, per sempre",
];

export const Pricing = () => {
  const [loading, setLoading] = useState(false);

  const buy = async () => {
    setLoading(true);
    try {
      await startCheckout();
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="acquista" className="relative overflow-hidden py-24 sm:py-32">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[30rem] w-[50rem] -translate-x-1/2 rounded-full bg-rose/25 blur-3xl" />
      <div className="relative mx-auto max-w-5xl px-5 sm:px-8">
        <Reveal className="text-center">
          <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-terracotta">Il tuo primo passo verso la libertà</span>
          <h2 className="mx-auto mt-4 max-w-2xl font-serif text-2xl tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Non devi cambiare tutta la tua azienda in una settimana.
            <span className="block italic text-terracotta">Devi solo iniziare.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-14 grid overflow-hidden rounded-[2.5rem] border border-ink/10 bg-white shadow-2xl shadow-espresso/10 lg:grid-cols-[1.3fr_1fr]">
            <div className="p-10 sm:p-12">
              <h3 className="font-serif text-xl text-ink">La Tua Prima Ora di Libertà</h3>
              <p className="mt-2 text-sm text-taupe">Il percorso operativo per imprenditrici che vogliono tornare padrone del proprio tempo.</p>
              <ul className="mt-8 space-y-4">
                {FEATURES.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-ink">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage/15 text-sage">
                      <Check className="h-3 w-3" />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col justify-center bg-terracotta p-10 text-center sm:p-12">
              <p className="text-sm text-linen/70 line-through">Valore €149</p>
              <p className="mt-2 font-serif text-6xl text-linen">€29</p>
              <p className="mt-2 text-xs font-medium uppercase tracking-[0.2em] text-linen/80">Pagamento unico · Accesso per sempre</p>
              <button
                onClick={buy}
                disabled={loading}
                data-testid="pricing-buy-button"
                className="mt-8 rounded-full bg-linen px-8 py-4 text-sm font-semibold text-terracotta shadow-lg shadow-espresso/20 transition-all hover:-translate-y-0.5 hover:bg-sand disabled:opacity-60"
              >
                {loading ? "Ti porto al pagamento…" : "Voglio la mia prima ora di libertà"}
              </button>
              <div className="mt-6 space-y-2 text-xs text-linen/80">
                <p className="flex items-center justify-center gap-1.5"><Lock className="h-3.5 w-3.5" /> Pagamento sicuro con Stripe</p>
                <p className="flex items-center justify-center gap-1.5"><Zap className="h-3.5 w-3.5" /> Accesso immediato dopo il pagamento</p>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <p className="mt-10 text-center font-serif text-lg italic text-taupe">
            "La tua libertà si costruisce una procedura alla volta."
          </p>
        </Reveal>
      </div>
    </section>
  );
};
